import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Poppins } from './Poppins';
import { Tooltip } from './Tooltip';

const StyledInputLabel = styled(Poppins).attrs((p) => {
  return { px: 14, ...p };
})`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.cflowerBlue};
  display: block;
`;

const LabelRow = styled.div`
  display: flex;
  gap: 4px;
`;

const CounterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
`;

const CharCounter = styled(Poppins).attrs((p) => {
  return { px: 12, ...p };
})<{ $over?: boolean }>`
  font-weight: 500;
  white-space: nowrap;
  color: ${({ theme, $over }) => ($over ? theme.colors.error : theme.colors.cflowerBlue)};
`;

type InputLabelProps = Omit<ComponentProps<typeof Poppins>, 'ref'> & {
  children: React.ReactNode;
  tooltip?: string;
  charCount?: { value?: string | null; max: number };
};

export const InputLabel: React.FC<InputLabelProps> = ({ children, tooltip, charCount, ...poppinsProps }) => {
  const label = tooltip ? (
    <LabelRow>
      <StyledInputLabel {...poppinsProps}>{children}</StyledInputLabel>
      <Tooltip infoIconStyle={{ transform: 'scale(0.7)', marginTop: '-6px' }} place="right" dataHtml={tooltip} />
    </LabelRow>
  ) : (
    <StyledInputLabel {...poppinsProps}>{children}</StyledInputLabel>
  );

  if (!charCount) return label;

  const count = charCount.value?.length ?? 0;

  return (
    <CounterRow>
      {label}
      <CharCounter $over={count > charCount.max}>
        {count} / {charCount.max}
      </CharCounter>
    </CounterRow>
  );
};
